'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Component } from 'react';
import createHocName from 'dashboard-components/decorator/createHocName';

// Adapted from:
// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/toClass.js
/**
 * This is primarily used for compatibility with general-store, as the connect
 * function expects a class component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default (FunctionalComponent => {
  var _class;
  return _class = class Container extends Component {
    constructor(...args) {
      super(...args);
      this.render = () => {
        const _this$props = this.props,
          passThrough = Object.assign({}, (_objectDestructuringEmpty(_this$props), _this$props));
        return /*#__PURE__*/_jsx(FunctionalComponent, Object.assign({}, passThrough));
      };
    }
  }, _class.displayName = createHocName('toClass', FunctionalComponent), _class;
});